import {config as dateColumnConfig} from '../../../common/DateColumn';

export const prop = 'relDate';
export const id = 'reportDateColumn';

export const config = (labels) => dateColumnConfig({fullId: id, label: labels.reportDate, prop});
